
  var _styles = {
  "live-player_video": {
    "width": "100%",
    "height": "100%",
    "OObjectFit": "cover !important",
    "objectFit": "cover !important"
  }
};



  module.exports = _styles;
  